<template>
    <div class="mt-3 col-md-12 no-shadow border radius-8 employee-table-wrapper">
        <div class="ibox-title dashboard_title px-0">
            <h4 class="clearfix">
                <span class="float-left">{{ title }}</span>
                <span class="float-right"></span>
            </h4>
        </div>
        <div class="ibox-content px-0">
            <table class="table dataTable custom-payrun-table no-sort-icon">
                <thead>
                    <tr class="table-head">
                        <th v-for="column in columns" :key="column.name" @click="sortBy(column.month)"
                            :class="sortKey === column.month ? (sortOrders[column.month] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;">{{ column.label }}</th>
                        <th class="text-right">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="hover-bg table-row border-bottom mx-2" v-for="(contribution, index) in paginatedData"
                        :key="contribution.id">
                        <td class="col-md-2 align-middle list-columns text-center">{{ contribution.run_date }}</td>
                        <td class="col-md-2 align-middle list-columns text-center">{{
                            formatMonthYear(contribution.month,contribution.year) }}</td>
                        <td class="col-md-1 align-middle list-columns text-center">{{
                            getRunTypeLabel(contribution.run_type) }}</td>
                        <td class="col-md-3">{{ getPolicyTypeLabel(contribution.policy_type) }}</td>
                        <td class="col-md-2 align-middle list-columns text-right">{{ formatMoney(contribution.amount) }}
                        </td>

                        <td class="col-md-1 text-center"> {{ getStatusLabel(contribution.status) }} </td>
                        <td>
                            <div class="float-right position-relative">
                                <b-button-toolbar>

                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                        style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false"><b-icon
                                            icon="three-dots-vertical"></b-icon></a>
                                    <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                        <b-button-group>
                                            <b-button variant="outline-secondary" @click="monthlyGfView(contribution)">
                                                <b-icon icon="view-list"></b-icon> Show Details
                                            </b-button>

                                            <!-- <b-button variant="outline-secondary" v-if="contribution.status == 1 && index==0" @click="showUnApproveModal(contribution.id)"> -->
                                            <b-button variant="outline-secondary" v-if="contribution.status == 1"
                                                @click="showConfirmModal(contribution.id, 3)">
                                                <b-icon icon="pencil"></b-icon> Unapprove
                                            </b-button>
                                            <!-- <b-button variant="outline-secondary" v-if="contribution.status == 0 && index==0" @click="showApproveModal(contribution.id)"> -->
                                            <b-button variant="outline-secondary" v-if="contribution.status == 0"
                                                @click="showConfirmModal(contribution.id, 2)">
                                                <b-icon icon="pencil"></b-icon> Approve
                                            </b-button>
                                            <!-- <b-button variant="outline-secondary"  v-if="contribution.status == 0 && index==0" @click="showDeleteModal(contribution.id)"> -->
                                            <b-button variant="outline-secondary" v-if="contribution.status == 0"
                                                @click="showConfirmModal(contribution.id, 1)">
                                                <b-icon icon="trash"></b-icon> Delete
                                            </b-button>
                                        </b-button-group>
                                    </div>
                                </b-button-toolbar>
                            </div>

                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">{{ blankmsg }}</div>
            <div v-else class="row py-2 no-margin">
                <div class="col-md-12 p-0 no-margin">
                    <ul class="pagination b-pagination float-left mb-0 mt-1">
                        <li class="page-item disabled m-2">View</li>
                        <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options"
                                @change="setFirstPage()"></b-form-select></li>
                        <li class="page-item disabled m-2">per page. Total {{ pagination.total }} records found.</li>
                    </ul>
                    <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#"
                        prev-text="Previous" next-text="Next" first-number last-number></b-pagination-nav>
                </div>
            </div>
        </div>

        <b-modal :id="st + 'bv-modal-monthly-gf-contribution-view'" size="lg" hide-footer :title="type_of_run === 1 ? 'Monthly Gratuity Fund Contribution'
            : (type_of_run === 2 ? 'Manual Gratuity Fund Contribution' : 'One-Off Gratuity Fund Contribution')">
            <!-- <gf-run-view :data="data" :type_of_run="type_of_run"></gf-run-view> -->

            <b-overlay :show="showoverlay" rounded="sm">
                <!-- <b-form @submit.stop.prevent="onSubmit"> -->
                <div class="clearfix">
                    <div class="col-md-12">
                        <div class="row clearfix">
                            <div class="col-md-10"> </div>
                            <div class="col-md-2">

                                <span v-if="data.status == 1" class="px-3 py-1 rounded ml-2"
                                    style="background: rgb(0, 193, 119); color: rgb(255, 255, 255);">Approved</span>
                                <span v-else class="px-3 py-1 rounded ml-2"
                                    style="background: rgb(232, 184, 15); color: rgb(255, 255, 255);">Draft</span>

                            </div>
                            <div class="col-md-4">
                                <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                    <dt class="col-md-12 pl-0 pr-0">Financial Year</dt>
                                    <dd class="col-md-12 pl-0 pr-0 mb-2">{{ data.fiscal_year }}</dd>
                                </dl>
                            </div>

                            <div class="col-md-4">
                                <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                    <dt class="col-md-12 pl-0 pr-0">Month</dt>
                                    <dd class="col-md-12 pl-0 pr-0 mb-2">{{ formatMonthYear(data.month, data.year) }}
                                    </dd>
                                </dl>
                            </div>

                            <div class="col-md-4">
                                <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                    <dt class="col-md-12 pl-0 pr-0">Run Date</dt>
                                    <dd class="col-md-12 pl-0 pr-0 mb-2">{{ data.run_date }}</dd>
                                </dl>
                            </div>

                            <div class="col-md-4">
                                <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                    <dt class="col-md-12 pl-0 pr-0">Type of Run</dt>
                                    <dd class="col-md-12 pl-0 pr-0 mb-2">{{ getRunTypeLabel(data.run_type) }}</dd>
                                </dl>
                            </div>

                            <div class="col-md-8"> </div>

                            <div class="col-md-8">
                                <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                    <dt class="col-md-12 pl-0 pr-0">Contribution Process</dt>
                                    <dd class="col-md-12 pl-0 pr-0 mb-2">{{ getPolicyTypeLabel(data.policy_type) }}</dd>
                                </dl>
                            </div>

                            <div class="col-md-4">
                                <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                    <dt class="col-md-12 pl-0 pr-0">Contribution Amount</dt>
                                    <dd class="col-md-12 pl-0 pr-0 mb-2">{{ formatMoney(data.amount) }}</dd>
                                </dl>
                            </div>

                            <div class="col-md-8">
                                <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                    <dt class="col-md-12 pl-0 pr-0">Details and Description</dt>
                                    <dd class="col-md-12 pl-0 pr-0 mb-4">{{ data.details }}</dd>
                                </dl>
                            </div>

                            <div class="col-md-4">
                                <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                    <dt class="col-md-12 pl-0 pr-0">Attachments</dt>
                                    <!-- <dd class="col-md-12 pl-0 pr-0 mb-4"><a href="#" @click.prevent="downloadContribution(data.id)">Download</a></dd> -->
                                     <dd class="col-md-12 pl-0 pr-0 mb-4"><b-icon icon="download" scale="2" @click.prevent="downloadContribution(data.id)"></b-icon></dd>
                                </dl>
                            </div>
                        </div>
                    </div>


                    <div class="row clearfix mt-5" v-if="data.status == 1">
                        <!-- <div class="col-md-4">
                                <b-button type="submit" class="btn-primary" variant="success"> Download Bank File </b-button>
                            </div> -->
                        <!-- <div class="col-md-4">
                                <b-button type="submit" class="btn-primary" variant="success"> Send to Bank </b-button>
                            </div> -->
                        <div class="col-md-12 text-center">
                            <!-- <b-button type="submit" class="btn-primary" variant="success"> Unapprove </b-button>        -->
                            <b-button type="submit" class="btn-primary" variant="success"
                                @click="showConfirmModal(data.id, 3, 'details_form')"> Unapprove </b-button>
                        </div>
                    </div>

                    <div class="row clearfix mt-5 d-flex align-items-center justify-content-center" v-else>
                        <div class="mr-2">
                            <b-button type="submit" class="btn-primary" variant="success"
                                @click="showConfirmModal(data.id, 1, 'details_form')"> Delete Run </b-button>
                        </div>
                        <div class="mr-2">
                            <b-button type="submit" class="btn-primary" variant="success"
                                @click="showEditModal(data.id, data.run_type)"> Edit Run </b-button>
                        </div>
                        <div class="">
                            <b-button type="submit" class="btn-primary" variant="success"
                                @click="showConfirmModal(data.id, 2, 'details_form')"> Approve </b-button>
                        </div>
                    </div>
                </div>

                <!-- </b-form> -->
            </b-overlay>
        </b-modal>

        <!-- Start: Confirmation Modal -->
        <b-modal :id="st + 'confirmation-modal'" :title="confirmation_msg" hide-footer>Please enter your password to
            continue:
            <br />
            <input id="approvepass" type="password" class="form-control" v-model="approvepass" name="approvepass">

            <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert"
                style="clear: both; margin-top: 10px;"> {{ incorrectpass }} </div>
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"
                @click="updateRun(accrual_id)">{{ btn_name }} <span v-if="loading != ''"><img
                        :src="$api_url + '/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block
                @click="$bvModal.hide(st + 'confirmation-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>
        <!-- End: Confirmation Modal -->

        <!-- Start: Rejwan: 24-05-2025 Gf run -->
        <b-modal :id="st + 'bv-modal-update-monthly-gf-contribution'" size="lg" hide-footer
            :title="gf_type == 'monthly' ? 'Update Monthly Gratuity Fund Contribution' : 'Update One-Off Gratuity Fund Contribution'">
            <gf-run-form :gf_type="gf_type" :gf_run_id="selected_id" :key="run_form_key"
                @listReturn="listReturn"></gf-run-form>
        </b-modal>
        <!-- End: Rejwan: 24-05-2025 Gf run -->
    </div>

</template>
<script>

export default {

    mounted() {

    },
    props: ['pageurl', 'status', 'fiscal_year', 'month', 'title', 'st'],

    data() {
        let sortOrders = {};
        let columns = [
            { label: 'Run Date', name: 'run_date' },
            { label: 'Month-Year', name: 'month_year' },
            { label: 'Type of Run', name: 'run_type' },
            { label: "Contribution Process", name: 'policy_type' },
            { label: "Employer's Contribution", name: 'amount' },
            { label: "Status", name: 'status' },

        ];

        columns.forEach((column) => { sortOrders[column.name] = -1; });
        return {
            showoverlay_list: false,
            accrual_runs: [],
            loading: '',
            accrual_id: 0,
            approvepass: '',
            incorrectpass: '',
            blankmsg: 'Fetching data..',
            columns: columns,
            sortKey: '',
            sortOrders: sortOrders,
            length: 10,
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
            length_options:
                [
                    { value: 5, text: "5" },
                    { value: 10, text: "10" },
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
            temp_length: 20,
            arrual_details: [],
            gf_type: '',

            type_of_run: '',
            data: {},

            // Rejwan
            confirmation_msg: '',
            mark_flag: 0,
            run_delete_msg: '',
            btn_name: '',
            showoverlay: false,
            selected_id: '',
            form_title: '',
            selected_run_type: 0,
            run_form_key: 0,
            // End: Rejwan

        }
    },
    methods: {
        // Start: Rejwan: 24-05-2025 Gf Run
        listReturn: function (data) {
            this.draft_key += 1;
            this.approved_key += 1;
            let currentObj = this;
            // if(data == 'run_form')
            this.$bvModal.hide(this.st+'bv-modal-update-monthly-gf-contribution');
            this.$bvModal.hide(this.st + 'bv-modal-monthly-gf-contribution-view');
            if (data.success == true) {
                currentObj.$bvToast.toast(data.message, {
                    title: `Success!!`,
                    variant: 'success',
                    solid: true
                });
            }
            currentObj.getAllAccrualRuns();
            // }
        },
        // End: Rejwan: 24-05-2025 Gf Run
        downloadContribution(id) {
            let formData = new FormData();
            formData.append('id', id);
            this.downloadBlobResponse(
                axios.post(this.$api_url + '/gf/contribution-run-document', formData, { responseType: 'blob' }),
                'loader', // your loader key in this component
                (data) => {
                    if (data.error) {
                        this.$bvToast.toast(data.error, {
                            title: 'Warning',
                            variant: 'danger',
                            solid: true,
                        });
                    }
                }
            );
        },
        getAllAccrualRuns: function () {
            if (this.status != null) {
                let currentObj = this;
                let formData = new FormData();
                formData.append('status', this.status);
                axios.post(this.$api_url + '/gf/run/list', formData).then(function (response) {
                    this.accrual_runs = response.data;
                    this.pagination.total = response.data.length;
                    if (this.accrual_runs.length == 0)
                        this.blankmsg = "Nothing found.";
                }.bind(this));
            }

        },
        formatMonthYear(month, year) {
            const monthNames = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ];
            if (month && year) {
                return `${monthNames[month - 1]}-${year}`;
            }
            return '';
        },
        getRunTypeLabel(run_type) {
            const runTypes = {
                1: 'Regular',
                2: 'Manual',
                3: 'One Off'
            };
            return runTypes[run_type] || 'Unknown';
        },
        getPolicyTypeLabel(policy_type) {
            const policyTypes = {
                0: 'Direct Balance',
                1: 'Dynamic Proportion',
                2: 'Actuarial Amount',
                3: 'Actuarial Rate',
                4: 'Actuarial Rate'
            };
            return policyTypes[policy_type] || 'Unknown';
        },
        getStatusLabel(status) {
            const statuses = {
                0: 'Draft',
                1: 'Approved'
            };
            return statuses[status] || 'Unknown';
        },
        showAccrualDetails: function (accrual_id) {
            let currentObj = this;
            let formData = new FormData();
            formData.append('id', accrual_id);
            axios.post(this.$api_url + '/gf/run/details', formData).then(function (response) {
                currentObj.arrual_details = response.data;

            }.bind(this));
        },
        // Start: Rejwan
        showConfirmModal: function (run_id, flg, from = '') {
            this.approvepass = "";
            this.mark_flag = flg;
            this.accrual_id = run_id;
            // if(from == '') {
            //     this.selected_profit = run_id;
            // }

            // 1 for delete
            if (flg == 1) {
                this.confirmation_msg = "Are you sure to delete this Accrual Run?";
                this.btn_name = "Delete";
            }
            // 2 for approval
            if (flg == 2) {
                this.confirmation_msg = "Are you sure to approve this Accrual Run"
                this.btn_name = "Approve";
            }
            // 3 for unapproval
            if (flg == 3) {
                this.confirmation_msg = "Are you sure to unapprove this Accrual Run"
                this.btn_name = "Unapprove";
            }
            this.$bvModal.show(this.st + 'confirmation-modal');
        },

        showEditModal(run_id, run_type) {
            this.$nextTick(() => {
                this.selected_id = run_id;
                this.selected_run_type = run_type
                if (run_type == 1 || run_type == 2) {
                    this.gf_type = 'monthly';
                } else if (run_type == 3) {
                    this.gf_type = 'oneoff';
                }
                // this.form_title="Update GF Relaized Profit Declaration";
                this.run_form_key += 1;
                this.$bvModal.show(this.st + 'bv-modal-update-monthly-gf-contribution');
            });
        },

        updateRun: function (pageflg) {
            if(this.approvepass == '') {
                this.$bvToast.toast('Password is required', {
                    title: `error`,
                    variant: 'danger',
                    solid: true
                });
                return ;
            }

            this.loading = 'load';
            let currentObj = this;

            let formData = new FormData();
            formData.append('id', pageflg);
            formData.append('status', this.mark_flag);

            if (this.approvepass != '') {
                var pass = this.approvepass;
                this.loading = 'load';
                formData.append('pass', pass);
            }


            axios.post(this.$api_url + '/gf/run/update', formData)
                .then(function (response) {
                    this.loading = '';

                    if (response.data.success == true) {
                        this.$bvModal.hide(this.st + 'confirmation-modal');
                        this.$bvModal.hide(this.st + 'bv-modal-monthly-gf-contribution-view');
                        // this.resetform();

                        currentObj.$bvToast.toast(response.data.message, {
                            title: `Success!!`,
                            variant: 'success',
                            solid: true
                        });
                        currentObj.getAllAccrualRuns();
                    }
                    else {
                        //Start: Sifat: 02-07-2025 Make monthly contribution run functional
                        this.$bvModal.hide(this.st + 'confirmation-modal');
                        this.$bvModal.hide(this.st + 'bv-modal-monthly-gf-contribution-view');
                        this.$bvToast.toast(response.data.error, {
                            title: `error`,
                            variant: 'danger',
                            solid: true
                        });
                        currentObj.getAllAccrualRuns();
                        //End:  Sifat: 02-07-2025 Make monthly contribution run functional
                    }
                    this.$emit('childToParent', { success: true });
                }.bind(this))
                .catch(function (error) {
                    currentObj.loading = '';
                    let message = 'Something went wrong.';
                    if (error.response && error.response.data) {
                        message = error.response.data.error || error.response.data.message || message;
                    }
                    currentObj.$bvToast.toast(message, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                });
        },
        // End: Rejwan

        

        getStatusText(value) {
            const statusItem = this.status.find((item) => item.value === String(value));
            return statusItem ? statusItem.text : "N/A";
        },

        monthlyGfView(data) {

            this.type_of_run = parseInt(data.run_type);
            this.data = data;
            this.$bvModal.show(this.st + 'bv-modal-monthly-gf-contribution-view');
        },
    },
    created: function () {
        this.getAllAccrualRuns();
    },
    computed:
    {
        filteredData() {
            let filtered_list = this.accrual_runs;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });
                if (filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;

            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {
                    let index = this.getIndex(this.columns, 'reorder', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    return (a === b ? 0 : a > b ? 1 : -1) * order;
                });
            }
            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },
    }
}
</script>
